import React from "react";
import ReactDOM from "react-dom/client";
// import ReactDOM from "react-dom";
import {BrowserRouter} from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
/* Bootstrap 5 */
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
/* Slick Slider */
import "rsuite/dist/rsuite.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
/* overlayscrollbars-react */
import "overlayscrollbars/css/OverlayScrollbars.css";
//react-modern-drawer
import "react-modern-drawer/dist/index.css";
/* Skeleton Style */
import "react-loading-skeleton/dist/skeleton.css";
/* Style Files */
import "./styles/reset.scss";
import "./styles/styles.scss";
import "./styles/menu.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// ReactDOM.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </React.StrictMode>,
//   document.getElementById("root")
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
